import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "copyButton"]

  copy() {
    const codeElement = this.activeCodeContent
    if (!codeElement) return

    const cleanText = this.cleanCodeText(codeElement)
    this.copyToClipboard(cleanText)
    this.updateCopyButtonState()
  }

  cleanCodeText(codeElement) {
    let text = codeElement.innerText
    if (codeElement.classList.contains("language-curl-example")) {
      text = text.replace(/^\s*\$ /gm, "")
    }
    return text
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text)
  }

  updateCopyButtonState() {
    const originalAriaLabel = this.copyButtonTarget.getAttribute("aria-label")
    this.copyButtonTarget.setAttribute("aria-label", "Copied")

    setTimeout(() => {
      this.copyButtonTarget.setAttribute("aria-label", originalAriaLabel)
    }, 2000)
  }

  get activeCodeContent() {
    const contentTarget = this.contentTargets[0]
    const selectors = [
      "pre.active",
      "[data-doc-examples-target='example'].active",
      "[data-doc-examples-target='example']:has(pre.active)"
    ]

    for (const selector of selectors) {
      const element = contentTarget.querySelector(selector)
      if (element) {
        return element.querySelector("code")
      }
    }

    // If no selector is active, take the first pre code
    const firstCode = contentTarget.querySelector("pre code")
    return firstCode || null
  }
}
